import { Button, Card, Col, Modal, Row } from "antd";
import { useMemo } from "react";
import FormCauseAnalysis, {
  FormCauseAnalysisSchema,
  formName,
} from "../../../components/forms/FormCauseAnalysis/FormCauseAnalysis";
import { useModal } from "../../../features/modals/useModal";
import type { Event } from "../../../types/events";
import styles from "../PageEvent.module.scss";
import useSubmit from "../../../components/forms/FormCauseAnalysis/useSubmit";
import spacing from "../../../components/ui/spacingConfig";
import { modalProps } from "../../../features/modals/modalProps";
import AttachmentPreview from "../../../components/ui/AttachmentPreview";

type Props = {
  eventData: Event | undefined;
  refetchEvent: () => void;
  className?: string;
  canAddCauseAnalysis: boolean;
  hasAnalysis: boolean;
};

const CardCauseAnalysis: React.FC<Props> = ({
  eventData,
  refetchEvent,
  className,
  canAddCauseAnalysis,
  hasAnalysis,
}) => {
  const { onShowModal, onHideModal, isModalOpen } = useModal();

  const defaultValues: FormCauseAnalysisSchema = useMemo(() => {
    return {
      description: "",
      attachedFiles: [],
      pilote: eventData?.pilotes[0]?.id || 0, // Hidden field, necessary backend side
      event: eventData?.id || 0, // Hidden field, necessary backend side
    };
  }, [eventData?.pilotes, eventData?.id]);

  const { createCauseAnalaysis, isLoading: isCreatingCause } = useSubmit({
    hideModal: onHideModal,
    refetchEvent,
  });

  const analysis = eventData?.causeAnalysis?.[0];

  console.log("defaultValues", defaultValues);
  console.log("analysis", analysis);

  return (
    <Card
      title="Analyse des causes"
      bordered={false}
      className={`${className} ${hasAnalysis ? styles.cardWithAnalysis : styles.cardNoAnalysis}`}
    >
      {/* If no cause analysis is defined */}
      {!analysis && (
        <Row
          style={{
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Button
            type="primary"
            onClick={onShowModal}
            disabled={!canAddCauseAnalysis}
          >
            DÃ©finir une analyse de cause
          </Button>
        </Row>
      )}

      {/* If cause analysis is defined */}
      {!!analysis && (
        <>
          <Row>
            <Col span={spacing.xxxs}>
              <p className="text-light-grey">Description</p>
            </Col>
            <Col span={spacing.s}>
              <p className="text-small-size">{analysis.description}</p>
            </Col>
          </Row>
          <Row>
            <Col span={spacing.xxxs}>
              <p className="text-light-grey">PiÃ¨ces jointes</p>
            </Col>
            <Col span={spacing.s}>
              <div className="attachments-container">
                {analysis.attachedFiles?.map((file) => (
                  <AttachmentPreview key={file.id} fileUrl={file.file} />
                ))}
                {!analysis.attachedFiles?.length && (
                  <p className="text-small-size">Aucune piÃ¨ce jointe</p>
                )}
              </div>
            </Col>
          </Row>
        </>
      )}

      <Modal
        {...modalProps}
        open={isModalOpen}
        onCancel={onHideModal}
        loading={isCreatingCause}
        title={<p>DÃ©finir une analyse des causes</p>}
        footer={
          <>
            <Button
              type="default"
              onClick={onHideModal}
              disabled={isCreatingCause}
            >
              Annuler
            </Button>
            <Button
              type="primary"
              htmlType="submit"
              disabled={false}
              loading={isCreatingCause}
              form={formName}
            >
              Ajouter
            </Button>
          </>
        }
      >
        <FormCauseAnalysis
          onSubmit={createCauseAnalaysis}
          defaultValues={defaultValues}
        />
      </Modal>
    </Card>
  );
};

export default CardCauseAnalysis;
